import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as widgets from '../../widgets'
import type { Collection } from '../collection'
import * as models from '../models'
import type { TypeParams } from '../types'

// TODO: This will be removed or differently implemented once page builder
// feature is created.
/**
 * When page is marked for editing, retrieving all page widgets previews.
 */
export const triggerWidgetsPreviews = store.effects.create(
  (
    feature: ec.Collection<TypeParams>['feature'],
    pageEc: Collection,
    previewPlugin: widgets.plugins.preview.Plugin,
  ) =>
    pageEc.plugins.currentEntityPlugin.feature.selectors
      .getEditedEntity()
      .asObservable.pipe(
        rxjs.map(page =>
          page?.content
            ? // TODO Both WidgetRef type and the way how we get all widgetRefs will
              // be removed and this whole effect will be refactored
              models.widget.WidgetRef.fromContent(page.content).filter(
                // FIXME: Currently, sending preview requests for the table
                // widgets will result in endless loop caused by the current way
                // how dynamic ec is bootstrapped for table widgets. Once that is
                // fixed we should be able to remove this filter
                widgetRef =>
                  !widgetRef.widget.alias?.includes('table') &&
                  !widgetRef.widget.id?.includes('table'),
              )
            : [],
        ),
        rxjs.mergeMap(widgetRefs => rxjs.from(widgetRefs)),
        rxjs.map(widgetRef =>
          previewPlugin.feature.actions.preview
            .from('triggerWidgetsPreviews (effect)')
            .create({
              flexibleIdentifier: widgetRef.widget,
            }),
        ),
      ),
)
